import { ConditionalRender } from '@/components/Helpers/ComponentRender/ConditionalRender';
import CircularLoader from '@/components/utils/CircularLoader';
import { FullScreenPageContainer } from '@/components/utils/FullScreenPageContainer';
import { LOGIN_PATH } from '@/constants/paths';
import { toast } from '@/hooks/use-toast';
import { useUserStore } from '@/hooks/useUserStore';
import { LocalStorage } from '@/utils/LocalStorage';
import { Button } from '@design-system/Button';
import { useQueryClient } from '@tanstack/react-query';
import { useLogoutQuery } from '@viome/viome-base/src/usecase/Login/LoginQuery';
import { Link } from 'react-router-dom';
import { Sentry } from '@/main';

export const EmailConfirmation = () => {
  const { user: userData } = useUserStore();
  const isLoggedIn = userData ? true : false;

  const { setUser } = useUserStore();
  const queryClient = useQueryClient();
  const { refetch: logout, isLoading } = useLogoutQuery({ enabled: false });

  const clearAllCachesAndState = () => {
    queryClient.clear();
    setUser(undefined);
    Sentry.setUser(null);
    LocalStorage.clear();
    LocalStorage.removeItem('user');
    LocalStorage.removeItem('bootup');
    LocalStorage.removeItem('auth_token');
    sessionStorage.clear();
  };

  const handleLogout = async () => {
    try {
      const response = await logout();

      if (response?.isError) {
        toast({
          variant: 'destructive',
          description: `Failed returning to login page, please try again`,
        });
      }
      clearAllCachesAndState();
    } catch (error) {
      toast({
        variant: 'destructive',
        description: `Failed returning to login page, please try again ${error}`,
      });
    }
  };

  return (
    <FullScreenPageContainer>
      <h2 className="text-4xl font-sans mb-4 mt-4 font-medium">
        Check your inbox
      </h2>
      <div className="flex">
        <p className="font-sans text-tertiary">
          You should receive an email within a few minutes. Click the link in
          the email to reset your password.
        </p>
      </div>
      <ConditionalRender
        conditions={[
          {
            when: isLoggedIn,
            render: (
              <Button
                type="button"
                className="md:max-w-sm py-3 text-white font-semibold bg-black rounded-lg mt-8"
                disabled={isLoading}
                onClick={handleLogout}
              >
                {isLoading ? <CircularLoader /> : 'Return to Login'}
              </Button>
            ),
          },
          {
            when: !isLoggedIn,
            render: (
              <Link to={LOGIN_PATH}>
                <Button
                  type="button"
                  className="w-full py-3 text-white font-semibold bg-black rounded-lg mt-8"
                >
                  Return to Login
                </Button>
              </Link>
            ),
          },
        ]}
      />
    </FullScreenPageContainer>
  );
};
